/* eslint-disable */
/** Date: 4/7/2019*/
/*RQI form with 1 required checkboxes checked*/
export default {
    inserted: function (el) {
        const button = el.querySelector('[type=submit]');
        let requiredEls = el.querySelectorAll('input:required,select:required');
        let requiredCheckboxes =  el.querySelectorAll('input[type="checkbox"]');
        
        button.disabled = true;

        if (requiredEls.length > 0) {
         
            let checkFormValidity = () => {

                let isFormValid = false;
                
                for (const requiredEl of requiredEls) {
                    if (requiredEl.validity.valid === true && checkBoxesValidation() !== false) {
                        isFormValid = true;
                    } 
                }
                button.disabled = !isFormValid;
            };

            // ---

            let checkBoxesValidation = () => {
                let checkedOne = Array.prototype.slice.call(requiredCheckboxes).some(x => x.checked);
                return checkedOne;
            };

            // ---

            for (const requiredEl of requiredEls) {
                requiredEl.addEventListener('input', function (evt) {
                    checkFormValidity();
                });
            }

            // ---

            for (const cb of requiredCheckboxes) {
                cb.addEventListener('change', function (evt) {
                    checkFormValidity();
                });
            }

            // Check form on load
            checkFormValidity();
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/directives/form-submit-checkbox.js